import { IContractLot, ILot, DetailLotEnum } from '../../../../models/generic';
import {
  Component,
  Output,
  EventEmitter,
  Input,
  Inject
} from '@angular/core';

import {
  DialogContractTypeEnum,
  IManagementContractsModalData
} from 'src/app/models/dialog';
import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { SnackbarType } from 'src/app/models/snackbar-type.enum';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-lots-group-dialog',
  templateUrl: './lots-group-dialog.component.html',
  styleUrls: ['./lots-group-dialog.component.scss']
})
export class LotsGroupDialogComponent {
  @Input() lotsList: Array<ILot> = [];
  @Input() lotOrigin?: ILot;
  @Input() typeLot: DetailLotEnum = this.data.template.typeLot!;
  @Input() originalContractIds: string[] = []; // IDs dos contratos originais do lote

  constructor(
    private _dialogService: ApiDialogService,
    private _snackbarService: SnackbarService,
    @Inject(MAT_DIALOG_DATA) public data: IManagementContractsModalData
  ) {}

  openAddContractModal(lot: ILot): void {
    const dataDialog: IManagementContractsModalData = {
      type: DialogContractTypeEnum.AddContract,
      lot: this.lotOrigin,
      contractsInLots: this.getContractsByLots(),
      template: {
        title: 'Adicionar novos contratos',
        textConfirmButton: 'Adicionar',
        typeLot: this.typeLot
      }
    };

    this._dialogService.openDialogContracts(dataDialog).then((response) => {
      const contractList = response as IContractLot[];

      if (contractList?.length > 0)
        this.insertContractsInLotGroup(lot, contractList);
    });
  }

  insertContractsInLotGroup(lot: ILot, contractList: IContractLot[]): void {
    contractList = contractList.filter(
      (contract) =>
        !lot.Contracts?.some(
          (someContract) => someContract.ContractId === contract.ContractId
        )
    );

    lot.Contracts?.push(...contractList);
  }

  addLotGroup(): void {
    const newLot: ILot = {
      AmountTotal: 0,
      Bank: '',
      Channel: '',
      CreateDate: '',
      BatchId: 0,
      BatchNumber: '',
      BatchStatus: '',
      NumberOfContracts: 0,
      Partner: '',
      Checked: false,
      Contracts: []
    };

    this.lotsList.push(newLot);
  }

  deleteLot(lot: ILot): void {
    if (lot.Contracts && lot.Contracts.length > 0) {
      this._snackbarService.openSnackBar(
        'Ainda há contratos neste lote!',
        SnackbarType.Danger
      );
    } else {
      let indexLot: number = this.lotsList.indexOf(lot);

      if (indexLot >= 0) this.lotsList.splice(indexLot, 1);
    }
  }

  getContractsByLots(): Array<IContractLot> {
    let contracts = this.lotsList.map((lot) => lot['Contracts']).flat();
    return contracts as IContractLot[];
  }

  get getAmountContract(): string {
    let totalValueFinancing = 0;

    this.lotsList?.[0]?.Contracts?.forEach((contract) => {
      if (
        contract.Status.toLowerCase() === 'a estornar' ||
        contract.Status.toLowerCase() === 'estornar' ||
        contract.Status.toLowerCase() === 'estornado parcial'
      ) {
        totalValueFinancing -= contract?.Amount ?? 0;
      } else {
        totalValueFinancing += contract?.Amount ?? 0;
      }
    });

    return totalValueFinancing.toLocaleString('pt-br', {
      style: 'currency',
      currency: 'BRL'
    });
  }
}
